var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrench"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.454 6.52192C15.4562 7.2703 15.2718 8.00743 14.9174 8.66658C14.563 9.32573 14.0498 9.88608 13.4243 10.2969C12.7987 10.7077 12.0806 10.9561 11.3349 11.0194C10.5892 11.0828 9.83947 10.9591 9.15359 10.6597L5.9075 14.4301C5.90001 14.4388 5.89128 14.4482 5.88318 14.4564C5.50882 14.8323 5.00049 15.044 4.46999 15.0451C3.9395 15.0462 3.43031 14.8365 3.05443 14.4621C2.67855 14.0878 2.46678 13.5794 2.46571 13.0489C2.46463 12.5184 2.67433 12.0093 3.04868 11.6334C3.05742 11.6252 3.06615 11.6165 3.07551 11.6089L6.83264 8.34818C6.49387 7.5775 6.37785 6.7273 6.49775 5.89403C6.61765 5.06075 6.96867 4.27776 7.51099 3.63385C8.05331 2.98995 8.76522 2.51092 9.56598 2.25109C10.3667 1.99126 11.2243 1.96103 12.0413 2.16384C12.1256 2.18477 12.2029 2.22726 12.2657 2.28714C12.3286 2.34701 12.3747 2.42221 12.3997 2.50534C12.4246 2.58846 12.4275 2.67665 12.408 2.76123C12.3886 2.84581 12.3474 2.92386 12.2886 2.98771L9.95193 5.53309L10.309 7.17924L11.956 7.52903L14.4918 5.17887C14.5555 5.11983 14.6333 5.07837 14.7178 5.05856C14.8023 5.03875 14.8905 5.04128 14.9738 5.06589C15.057 5.0905 15.1324 5.13636 15.1925 5.19894C15.2526 5.26152 15.2954 5.33868 15.3167 5.42282C15.4072 5.78221 15.4533 6.15132 15.454 6.52192Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFix);
export default __webpack_public_path__ + "static/media/fix.5fdcd43ca2a18614ec5ba69f17b7d1da.svg";
export { ForwardRef as ReactComponent };